import { fetchPrivateApi } from '@/lib/api/apiServiceBase.ts';
import { MyAccessDto } from '@/features/dashboard/_root/types/MyAccessDto.ts';
import UserAccessDto from '@/features/auth/login/types/UserAccessDto';
import { normalizeMyAccess } from '@/features/dashboard/_root/api/myAccessNormalizer.ts';

const userAccessApi = {
  getMe: async (): Promise<MyAccessDto> => {
    const response = await fetchPrivateApi<MyAccessDto | UserAccessDto[]>(
      'GET',
      `access`,
      undefined,
      { skipTenantId: true },
    );
    return normalizeMyAccess(response);
  },
};

export default userAccessApi;
